import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type AdditionalPaymentCategoryEntity } from '@/libs/api'
import type { ReportType } from '@/libs/api/types'

import { getAdditionalPaymentCategoriesSelectQueryOptions } from '../query-options'

/**
 * Select用の追加支払種別一覧のUseQuery
 */
export const useAdditionalPaymentCategoriesSelectQuery = (
  tenantKey: string,
  reportType: ReportType,
  options?: {
    disabled: boolean
  }
): UseQueryResult<AdditionalPaymentCategoryEntity[]> => {
  const disabled = options?.disabled ?? false
  return useQuery<AdditionalPaymentCategoryEntity[]>({
    ...getAdditionalPaymentCategoriesSelectQueryOptions(tenantKey, reportType),
    enabled: !disabled,
    retry: false
  })
}
